const mapToProduct = require('../utils/map-csv-product-to-product')

/**
 * A product.
 * @typedef {Object} Product
 * @property {string} id
 * @property {string} sku
 * @property {string} skuDescription
 * @property {string} gtin
 * 
 */
class Product {
	static fromCsvItem(csvItem) {
		return new Product(mapToProduct(csvItem))
	}
	constructor(data) {
		Object.assign(this, data)
	}
	

}

module.exports = Product